import { useEffect } from 'react'
import { X } from 'lucide-react'
import { cn } from '@/lib/utils'

/** Modal simples com overlay. `size`: sm|md|lg|full. */
export function Dialog({ open, onClose, title, description, children, footer, size = 'md' }) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') onClose?.()
    }
    if (open) document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null

  const sizes = {
    sm: 'max-w-sm',
    md: 'max-w-lg',
    lg: 'max-w-3xl',
    full: 'max-w-[95vw] h-[92vh]',
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className={cn('relative z-10 w-full bg-card text-card-foreground rounded-lg border border-border shadow-lg flex flex-col', sizes[size])}>
        <div className="flex items-start justify-between p-6 pb-2">
          <div>
            {title && <h2 className="text-lg font-semibold">{title}</h2>}
            {description && <p className="text-sm text-muted-foreground mt-1">{description}</p>}
          </div>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground rounded-md p-1">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="p-6 pt-2 overflow-auto flex-1">{children}</div>
        {footer && <div className="flex justify-end gap-2 p-6 pt-2 border-t border-border">{footer}</div>}
      </div>
    </div>
  )
}
